import React from 'react';
import { useNavigate } from 'react-router-dom';

const DISPLAY_SLOTS = [
  {
    displayLabel: 'Smart Watches',
    searchQuery: 'smart watch',
    placeholderImg:
      'https://images.unsplash.com/photo-1523275335684-37898b6baf30?auto=format&fit=crop&w=800&q=80',
  },
  {
    displayLabel: 'Cars',
    searchQuery: 'car',
    placeholderImg:
      'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=800&q=80',
  },
  {
    displayLabel: 'Mobile Phones',
    searchQuery: 'mobile phone',
    placeholderImg:
      'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?auto=format&fit=crop&w=800&q=80',
  },
];

/**
 * Alibaba-style center column: three "Frequently searched" tiles.
 */
export default function MarketplaceHeroBento({ featuredProducts = [] }) {
  const navigate = useNavigate();
  const featured = featuredProducts || [];

  const cards = DISPLAY_SLOTS.map((slot, i) => {
    const p = featured[i];
    return {
      key: p ? `fp-${p.id}` : `slot-${i}`,
      displayLabel: slot.displayLabel,
      img: slot.placeholderImg,
      href: p?.id ? `/product/${p.id}` : `/products?search=${encodeURIComponent(slot.searchQuery)}`,
    };
  });

  return (
    <div
      className="mh-hero-alibaba-column mh-bento-hero-col"
      style={{ display: 'flex', flexDirection: 'column', gap: 0, height: '100%', minHeight: 0 }}
    >
      <div
        className="mh-alibaba-freq-row"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
          gap: 10,
          flex: '1 1 auto',
          alignContent: 'stretch',
          height: '100%',
        }}
      >
        {cards.map((c) => (
          <button
            key={c.key}
            type="button"
            onClick={() => navigate(c.href)}
            className="mh-freq-alibaba-card group"
            style={{
              display: 'flex',
              flexDirection: 'column',
              borderRadius: 10,
              background: '#fff',
              border: '1px solid #ebebeb',
              boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
              overflow: 'hidden',
              cursor: 'pointer',
              textAlign: 'left',
              height: '100%',
              minHeight: 220,
              transition: 'box-shadow .25s ease, transform .25s ease, border-color .25s ease',
            }}
          >
            {/* Label section */}
            <div style={{ padding: '10px 12px 6px', flexShrink: 0 }}>
              <p style={{ fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.08em', color: '#aaa', margin: 0 }}>
                Frequently searched
              </p>
              <p
                style={{ fontSize: 13, fontWeight: 700, color: '#1b1b1b', lineHeight: 1.3, marginTop: 3, marginBottom: 0 }}
                className="group-hover:text-[#ff6a00] transition-colors"
              >
                {c.displayLabel}
              </p>
            </div>
            {/* Image fills remaining space */}
            <div
              style={{
                flex: '1 1 auto',
                margin: '0 8px 8px',
                borderRadius: 8,
                overflow: 'hidden',
                background: '#f5f5f5',
                minHeight: 120,
              }}
            >
              <img
                src={c.img}
                alt=""
                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', minHeight: 120, transition: 'transform .45s ease' }}
                className="group-hover:scale-[1.04]"
              />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
